export enum AutoFunnelStepType {
  LANDINGS = 'landings',
  OFFER_PAGES = 'offerPages',
  CONFIRM = 'confirm',
  AUTORESPONDERS = 'autoResponders',
  WEBINAR = 'webinars',
  THANK_YOU_LANDING_PAGE = 'thankYouLandingPage',
  OTO_PAGES = 'otoPages',
}
